import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { finalize, tap } from 'rxjs';

import { ProfileService } from '../../../services/profile.service';
import { PREFERENCE_KEYS } from '~core/constants/global.constants';
import { ONBORADING_COMPLETED_STEP } from '~console/app/~shared/constants/global.constants';

@Component({
  selector: 'app-onboarding-guide',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './onboarding-guide.component.html',
  styleUrls: ['./onboarding-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingGuideComponent {
  private readonly _dialogRef = inject(MatDialogRef<OnboardingGuideComponent>);
  private readonly _profileService = inject(ProfileService);

  readonly steps = ONBORADING_COMPLETED_STEP;

  currentStepIndex = signal(0);
  loading = signal(false);

  next(): void {
    if (this.currentStepIndex() < this.steps.length - 1) {
      this.currentStepIndex.update(i => i + 1);
    } else {
      this.finish();
    }
  }

  prev(): void {
    if (this.currentStepIndex() > 0) {
      this.currentStepIndex.update(i => i - 1);
    }
  }

  finish(): void {
    this.loading.set(true);
    this._profileService
      .setPreference({
        [PREFERENCE_KEYS.ONBOARDING_CONSOLE_COMPLETED]: true
      })
      .pipe(
        tap({
          next: () => {
            this._dialogRef.close(true);
          },
          error: () => {
            this._dialogRef.close(true);
          }
        }),
        finalize(() => this.loading.set(false))
      )
      .subscribe();
  }
}
